var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWinnerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 26,
    viewBox: "0 0 20 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8067 15.5053C18.2247 13.8683 19.0827 11.733 19.0827 9.3973C19.0827 4.24264 14.904 0.0639648 9.74935 0.0639648C4.59469 0.0639648 0.416016 4.24264 0.416016 9.3973C0.416016 11.6278 1.19845 13.6756 2.50382 15.2811L1.13331 22.2134C0.94441 23.169 1.2915 24.1515 2.0387 24.7763C2.78591 25.4011 3.81433 25.5689 4.72134 25.2138L9.7596 23.2417L14.7774 25.2058C15.6893 25.5628 16.7234 25.3912 17.4712 24.7589C18.219 24.1266 18.56 23.1353 18.3595 22.1767L16.9331 15.3562C16.8915 15.4063 16.8494 15.456 16.8067 15.5053ZM14.6271 17.3562C13.2076 18.2279 11.5372 18.7306 9.74935 18.7306C7.93908 18.7306 6.24918 18.2153 4.81838 17.3232L3.74935 22.7306L9.11302 20.6311C9.52928 20.4682 9.98993 20.4682 10.4062 20.6311L15.7493 22.7226L14.6271 17.3562Z",
    fill: "#FFD84D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinnerIcon);
export default __webpack_public_path__ + "static/media/winner-icon.f6869fa22e5787da436819cdb47dfbda.svg";
export { ForwardRef as ReactComponent };